<template>
  <div class="studio-product-playlists mt-5">
    <div class="text-center vh-100" v-if="isLoading">
      <HMSpinner class="mt-4" />
    </div>
    <div
      v-else
      v-for="playlist in sortedPlaylists"
      :key="playlist.id"
      class="col-lg-12 col-12 mb-4 p-0"
    >
      <PlaylistStudentItemCard
        v-if="isVisibleCard(playlist)"
        :playlist="playlist"
        :showOnlyFeatured="showOnlyFeatured"
        class="pl-3 pr-3"
        :review="review"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import PlaylistStudentItemCard from '@/web/components/products/PlaylistStudentItemCard';
import HMSpinner from '@/web/components/common/HMSpinner.vue';

export default Vue.extend({
  name: 'StudioProductPlaylists',
  components: {
    PlaylistStudentItemCard,
    HMSpinner,
  },
  props: {
    showOnlyFeatured: {
      type: Boolean,
      default: false,
    },
    review: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      sortedPlaylists: [],
    };
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;
        const playlists = await this.$store.dispatch(
          'product/getStudentPlaylists',
          {
            studioURL: this.studioURL,
            productId: this.product.id,
          }
        );
        this.sortedPlaylists = this.sortPosition([...playlists]);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load information',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      } finally {
        this.isLoading = false;
      }
    },
    isVisibleCard(playlist) {
      return (
        !this.showOnlyFeatured || (this.showOnlyFeatured && playlist.featured)
      );
    },
    sortPosition(items) {
      return items.sort((a, b) => a.position - b.position);
    },
  },
  mounted() {
    this.loadData();
  },
});
</script>

<style lang="scss">
.review {
  pointer-events: none;
}
</style>
